
import {throwError as observableThrowError, of as observableOf,  Observable } from 'rxjs';

import {catchError, map, switchMap} from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { considerPermissions } from 'express-authorization';
import { EcaSecurityAuthenticationService } from '../security-authentication/security-authentication.service';

@Injectable({
  providedIn: 'root'
})
export class EcaSecurityAuthorizationService {
  private _ecaSecurityAuthenticationService = inject(EcaSecurityAuthenticationService);


  checkPermission(resource): Observable<boolean> {
    return this._ecaSecurityAuthenticationService
      .getUser().pipe(
      map((ecaUser) => this.considerEcaSubject(ecaUser).isPermitted(resource)),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      catchError((err) => observableOf(false), ));
  }

  controlPermission(resource): Observable<boolean> {
    return this.checkPermission(resource).pipe(
      switchMap((hasPermission) => {
        if (hasPermission) {
          return observableOf(true);
        } else {
          return observableThrowError(false);
        }
      }),
      catchError(() => observableThrowError(`User does not have permission for '${resource}'`)), );
  }

  private considerEcaSubject(subject) {
    let permissions = [];
    if (subject && subject.allow) {
      permissions = subject.allow;
    }
    return considerPermissions(permissions);
  }
}
